export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=798a7563"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customers/Index.vue?vue&type=template&id=798a7563
// module id = 2552
// module chunks = 31